import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export interface BulkConfigAction {
  name: string;
  action: () => void;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
}

export interface BulkConfigStepProps {
  title: string;
  children: ReactNode;
  topActions: BulkConfigAction[];
  bottomActions: BulkConfigAction[];
  error?: string;
  onCancel?: () => void;
}

// Reusable UI component for any bulk config step
export default function BulkConfigStep(props: BulkConfigStepProps) {
  const { title, children, topActions, bottomActions, error, onCancel } = props;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Box className="bulk-config-step-title-container">
        <Typography
          variant="h4"
          textAlign="center"
          gutterBottom
          sx={{ marginTop: 1 }}
        >
          {title}
        </Typography>
      </Box>
      <Box sx={{ padding: '0 10px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            columnGap: 1,
          }}
        >
          {error && (
            <Typography color="red" textAlign="center" marginTop={1}>
              {error}
            </Typography>
          )}
          {topActions.map((a) => (
            <Button
              key={a.name}
              color="secondary"
              variant="contained"
              onClick={a.action}
              startIcon={a.startIcon}
              endIcon={a.endIcon}
              style={{
                color: 'white',
                marginTop: '20px',
                marginBottom: '10px',
              }}
            >
              {a.name}
            </Button>
          ))}
        </Box>
        {children}
        <Box sx={{ display: 'flex', justifyContent: 'center', columnGap: 1 }}>
          <Button
            key={'cancel'}
            color="secondary"
            variant="outlined"
            onClick={onCancel}
            style={{
              color: '#36AFA5',
              marginTop: '20px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </Button>
          {bottomActions.map((a) => (
            <Button
              key={a.name}
              color="secondary"
              variant="contained"
              onClick={a.action}
              startIcon={a.startIcon}
              endIcon={a.endIcon}
              style={{
                color: 'white',
                marginTop: '20px',
                marginBottom: '10px',
              }}
            >
              {a.name}
            </Button>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
